import { isNil, isPlainObject, isString } from 'lodash';

/**
 * Parse a consent-code list from either shape the form can hold:
 * the multi-select's selected-option objects (after a user interaction) or a
 * JSON-stringified code array (the DOM hidden input / a populated saved file).
 *
 * @param {*} rawValue - Form value in either shape
 * @returns {array} Array of consent code strings
 */
export default function parseConsentCodes(rawValue) {
  if (isNil(rawValue)) {
    return [];
  }
  if (Array.isArray(rawValue)) {
    return rawValue.map(option => (isPlainObject(option) ? option.value : option));
  }
  if (isString(rawValue) && rawValue !== '') {
    try {
      const parsed = JSON.parse(rawValue);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}
